import { render, staticRenderFns } from "./BottomMatColorLineItem.vue?vue&type=template&id=65dcb5ba&scoped=true&"
import script from "./BottomMatColorLineItem.vue?vue&type=script&lang=ts&"
export * from "./BottomMatColorLineItem.vue?vue&type=script&lang=ts&"
import style0 from "./BottomMatColorLineItem.vue?vue&type=style&index=0&id=65dcb5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcb5ba",
  null
  
)

export default component.exports